'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.curryApiToService = exports.setApiHeaders = exports.api = exports.setApi = exports.addService = exports.services = undefined;

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _booking = require('./service/booking');

var _booking2 = _interopRequireDefault(_booking);

var _loyaltyCard = require('./service/loyaltyCard');

var _loyaltyCard2 = _interopRequireDefault(_loyaltyCard);

var _user = require('./service/user');

var _user2 = _interopRequireDefault(_user);

var _voucher = require('./service/voucher');

var _voucher2 = _interopRequireDefault(_voucher);

var _merchant = require('./service/merchant');

var _merchant2 = _interopRequireDefault(_merchant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var services = exports.services = {
  Booking: _booking2.default,
  LoyaltyCard: _loyaltyCard2.default,
  User: _user2.default,
  Voucher: _voucher2.default,
  Merchant: _merchant2.default

  // this updates whenever the user's access_token changes
};var apiInstance;

var requireService = function requireService(name) {
  return curryApiToService(apiInstance, services[name]);
};

var addService = exports.addService = function addService(name, service) {
  services[name] = service;
};

var setApi = exports.setApi = function setApi(instance) {
  apiInstance = instance;
};

var api = exports.api = function api() {
  return apiInstance;
};

var setApiHeaders = exports.setApiHeaders = function setApiHeaders(headers) {
  apiInstance.setHeaders(headers);
};

var curryApiToService = exports.curryApiToService = function curryApiToService(api, service) {
  return _fp2.default.mapValues(function (method) {
    return _fp2.default.curry(method)(api);
  }, service);
};

exports.default = requireService;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/service.js
// module id = 433
// module chunks = 0